import apiSimple, { apiSimple as hubApiSimple } from './api'

// Buscar todos os tickets de suporte
export const getSupportTickets = async (storeId, page = 0, limit = 20, filters = {}) => {
  try {
    // Preparar parâmetros de filtro
    const params = { 
      storeId,
      page,
      limit
    }

    // Adicionar filtros se fornecidos
    if (filters.keyword) {
      params.keyword = filters.keyword
    }
    if (filters.status) {
      params.status = filters.status
    }
    if (filters.category) {
      params.category = filters.category
    }
    
    const response = await apiSimple.get('/clickup/tasks', {
      params
    })
    
    const data = response?.data || {}
    const tasks = data.tasks || []
    
    // Processar os dados dos tickets
    const processedTickets = tasks?.map(task => {
      // Extrair campos customizados
      const customFields = task.custom_fields || []
      
      const getCustomFieldValue = (fieldName) => {
        const field = customFields.find(f => f.name === fieldName)
        return field.type_config.options.find(f => f.orderindex === field.value) || ''
      }
      
      const getCustomFieldText = (fieldName) => {
        const field = customFields.find(f => f.name === fieldName)
        return field?.value_richtext || field?.value || ''
      }
      
      // Mapear status do ClickUp para status interno
      const mapStatus = (clickupStatus) => {
        switch (clickupStatus?.status?.toLowerCase()) {
          case 'to do':
            return 'aberto'
          case 'em progresso':
            return 'em_andamento'
          case 'complete':
          case 'done':
            return 'resolvido'
          case 'closed':
            return 'fechado'
          default:
            return 'aberto'
        }
      }
      
      // Mapear prioridade do ClickUp para prioridade interna
      const mapPriority = (clickupPriority) => {
        switch (clickupPriority?.priority?.toLowerCase()) {
          case 'urgent':
            return 1
          case 'high':
            return 2
          case 'normal':
            return 3
          case 'low':
            return 4
          default:
            return 3
        }
      }
      
      return {
        id: task.id,
        title: task.name,
        description: task.text_content || task.description || '',
        status: mapStatus(task.status),
        priority: mapPriority(task.priority),
        userName: getCustomFieldText('👤 Nome Usuário'),
        email: getCustomFieldText('✉️ E-mail de Contato'),
        category: getCustomFieldValue('Categoria'),
        classification: getCustomFieldValue('Classificação'),
        storeId: getCustomFieldText('🆔 StoreID'),
        cnpj: getCustomFieldText('🕋 CNPJ'),
        storeName: getCustomFieldText('🕋 Loja'),
        createdAt: task.date_created,
        updatedAt: task.date_updated,
        closedAt: task.date_closed,
        completedAt: task.date_done,
        creator: {
          id: task.creator?.id,
          name: task.creator?.username,
          email: task.creator?.email,
          profilePicture: task.creator?.profilePicture
        },
        url: task.url,
        archived: task.archived,
        // Campos adicionais do ClickUp
        clickupId: task.id,
        clickupStatus: task.status,
        clickupPriority: task.priority,
        orderIndex: task.orderindex,
        teamId: task.team_id,
        listId: task.list?.id,
        listName: task.list?.name,
        projectId: task.project?.id,
        projectName: task.project?.name,
        spaceId: task.space?.id,
        // Campos customizados adicionais
        solutionApplied: getCustomFieldText('✅ Solução Aplicada'),
        rootCause: getCustomFieldText('🐞 Causa Raiz'),
        // Anexos e comentários (se disponíveis)
        attachments: task.attachments || [],
        comments: task.comments || [],
        // Watchers
        watchers: task.watchers || [],
        // Assignees
        assignees: task.assignees || []
      }
    })
    
    return {
      tickets: processedTickets,
      pagination: {
        page,
        limit,
        total: data.total || processedTickets.length,
        hasNextPage: !data.last_page,
        hasPreviousPage: page > 1,
        totalPages: Math.ceil((data.total || processedTickets.length) / limit)
      }
    }
    
  } catch (error) {
    console.error('Erro ao buscar tickets de suporte:', error)
    throw error
  }
}

export const searchCustomerByCpf = async (cpf, storeId) => {
  const response = await hubApiSimple.get('/customers/search-cpf', {
    params: {
      cpf,
      storeId
    }
  })

  return response.data
}

// Buscar um ticket específico por ID
export const getSupportTicket = async (ticketId) => {
  try {
    const response = await apiSimple.get(`/clickup/tasks/${ticketId}`)
    return response.data
  } catch (error) {
    console.error('Erro ao buscar ticket de suporte:', error)
    throw error
  }
}

export const postCommentSupport = async (ticketId, commentData) => {
  try {
    const formData = new FormData();
    formData.append("comment", commentData.content);

    console.log('Debug - commentData:', commentData);
    console.log('Debug - attachments:', commentData.attachments);

    if (commentData.attachments && commentData.attachments.length > 0) {
      for (let i = 0; i < commentData.attachments.length; i++) {
        const file = commentData.attachments[i];
        console.log('Debug - anexando arquivo:', file.name, file.type, file.size);
        formData.append("attachments", file);
      }
    }

    // Debug FormData
    console.log('Debug - FormData entries:');
    for (let pair of formData.entries()) {
      console.log(pair[0] + ':', pair[1]);
    }

    const response = await apiSimple.post(`/clickup/tasks/${ticketId}/comments`, formData,{
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  } catch (error) {
    console.error('Erro ao enviar comentário:', error)
    toast.error('Erro ao enviar comentário')
    throw error
  }
}

// Encerrar um ticket de suporte
export const closeTicket = async (ticketId, reason, isResolved) => {
  try {
    const response = await apiSimple.put(`/clickup/tasks/${ticketId}/close`, {
      reason: reason,
      isResolved: isResolved
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao encerrar ticket de suporte:', error);
    toast.error('Erro ao encerrar chamado');
    throw error;
  }
};

// Criar um novo ticket de suporte
// Seu código frontend corrigido
export const createSupportTicket = async (ticketData) => {
  try {
    const formData = new FormData();

    formData.append("storeId", ticketData.storeId);
    formData.append("cnpj", ticketData.cnpj);
    formData.append("storeName", ticketData.storeName);
    formData.append("userName", ticketData.userName);
    formData.append("email", ticketData.email);
    formData.append("whatsapp", ticketData.whatsapp || "");
    formData.append("cpf", ticketData.cpf);
    formData.append("category", ticketData.category);
    formData.append("subcategory", ticketData.subcategory || "");
    formData.append("classification", ticketData.classification);
    formData.append("priority", ticketData.priority);
    formData.append("status", ticketData.status);
    formData.append("title", ticketData.title);
    formData.append("description", ticketData.description);
    
    // CORREÇÃO: Enviar cada arquivo individualmente
    if (ticketData.attachments && ticketData.attachments.length > 0) {
      for (let i = 0; i < ticketData.attachments.length; i++) {
        formData.append("attachments", ticketData.attachments[i]);
      }
    }
    
    const response = await apiSimple.post("/clickup/tasks", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    
    return response.data
    
  } catch (error) {
    console.error('Erro ao criar ticket de suporte:', error)
    throw error
  }
}

export const getOptionsClickup = async () => {
  try {
    
    const response = await apiSimple.get('/clickup/options')
    return response.data
    
  } catch (error) {
    console.error('Erro ao criar ticket de suporte:', error)
    throw error
  }
}

// Atualizar um ticket de suporte
export const updateSupportTicket = async (ticketId, ticketData) => {
  try {
    const response = await apiSimple.put(`/support/tickets/${ticketId}`, ticketData)
    return response.data
  } catch (error) {
    console.error('Erro ao atualizar ticket de suporte:', error)
    throw error
  }
}

// Deletar um ticket de suporte
export const deleteSupportTicket = async (ticketId) => {
  try {
    const response = await apiSimple.delete(`/support/tickets/${ticketId}`)
    return response.data
  } catch (error) {
    console.error('Erro ao deletar ticket de suporte:', error)
    throw error
  }
}

// Adicionar comentário a um ticket
export const addTicketComment = async (ticketId, commentData) => {
  try {
    const response = await apiSimple.post(`/support/tickets/${ticketId}/comments`, commentData)
    return response.data
  } catch (error) {
    console.error('Erro ao adicionar comentário ao ticket:', error)
    throw error
  }
}

// Buscar comentários de um ticket
export const getTicketComments = async (ticketId) => {
  try {
    const response = await apiSimple.get(`/support/tickets/${ticketId}/comments`)
    return response.data
  } catch (error) {
    console.error('Erro ao buscar comentários do ticket:', error)
    throw error
  }
}

// Atualizar status de um ticket
export const updateTicketStatus = async (ticketId, status) => {
  try {
    const response = await apiSimple.patch(`/support/tickets/${ticketId}/status`, { status })
    return response.data
  } catch (error) {
    console.error('Erro ao atualizar status do ticket:', error)
    throw error
  }
}

// Buscar estatísticas de tickets
export const getTicketStats = async () => {
  try {
    const response = await apiSimple.get('/support/tickets/stats')
    return response.data
  } catch (error) {
    console.error('Erro ao buscar estatísticas de tickets:', error)
    throw error
  }
}
